// Browser replacement for @protobufjs/inquire, whose eval('require') violates a CSP
// without 'unsafe-eval'. Nothing can be required in a browser, so report every module
// as missing; the WebFs websocket client injects Long itself.
module.exports = function inquire() {
    return undefined;
};
